/* eslint-disable */
import * as shared from '../shared';

googletag.cmd.push(function () {
  // institution_index_rightup
  googletag.defineSlot(
    '/21678620621/medicalnote_hospital_searchtop_right_20181003',
    [[300, 600], [160, 600], [230, 675]],
    'div-gpt-ad-1538556702560-0'
  ).addService(googletag.pubads());

  // institution_index_bottom
  googletag.defineSlot(
    '/21678620621/medicalnote_hospital_searchtop_bottom_20181003',
    [[728, 90], [728, 135]],
    'div-gpt-ad-1538556840880-0'
  ).addService(googletag.pubads());

  shared.setDiseaseKeyValue();
  shared.setSymptomKeyValue();
  shared.setContentTypeKeyValue();
  shared.setHospitalDepartmentKeyValue();
  shared.setEnvKeyValue();
  shared.setAdTagKeyValue();
  shared.setPathKeyValue();
  shared.setDoctorKeyValue();

  if (!shared.isMobile()) googletag.pubads().enableSingleRequest();
  googletag.pubads().collapseEmptyDivs();
  googletag.enableServices();
});
/* eslint-enable */
